import apiClient from '@shared/api/apiClient';

/**
 * user에게 설정된 대결자를 삭제하는 api
 * @returns {Promise<Object>} 서버 응답 데이터
 */
async function deleteEmployeeDelegate() {
  const response = await apiClient.put(
    '/v1/users/me/delegate/delete',
    {},
    {
      withAuth: true,
    },
  );
  return response.data;
}

/**
 * 직원의 이름으로 직원정보 검색 api
 * @param {String} employeeName - 조회할 직원의 이름
 * @returns {Promise<Object>} 서버 응답 데이터
 */
async function getEmployeeByName(employeeName) {
  const response = await apiClient.get(`/v1/users/employees/search/${employeeName}`, {
    withAuth: true,
  });
  return response.data;
}

/**
 * 부서의 직원 정보 조회 api
 * @param {number} teamCode - 조회할 부서 ID
 * @returns {Promise<Object>} 서버 응답 데이터
 */
async function getEmployeeByTeam(teamCode) {
  const response = await apiClient.get(`/v1/users/employees/team/${teamCode}`, {
    withAuth: true,
  });

  return response.data;
}

/**
 * 로그인 한 사람의 대결자 조회 API
 * @returns {Promise<Object>} 서버 응답 데이터
 */
async function getEmployeeDelegate() {
  const respone = await apiClient.get('/v1/users/me/delegate', {
    withAuth: true,
  });
  return respone.data;
}

/**
 * 회사의 대표 직원 리스트 조회 API
 * @param {number} companyId
 * @returns {Promise<Object>} 서버 응답 데이터
 */
async function getEmployeesByCompany(companyCode) {
  const response = await apiClient.get(`/v1/users/employees/company/${companyCode}`, {
    withAuth: true,
  });
  return response.data;
}

/**
 * user 에게 설정된 대결자를 변경하는 api
 * @param {number} stead_enumber - 사원 번호
 * @returns {Promise<Object>} 서버 응답 데이터
 */
async function putEmployeeDelegate(stead_enumber) {
  const response = await apiClient.put(
    `/v1/users/me/delegate/${stead_enumber}`,
    {},
    {
      withAuth: true,
    },
  );
  return response.data;
}

/**
 * 로그인 사람의 사원 서명 조회
 * @returns {Promise<Object>} 서버 응답 데이터
 */
async function getMySign() {
  const respone = await apiClient.get('/v1/users/me/signature', {
    withAuth: true,
  });
  return respone.data;
}

/**
 * 사용자 서명 등록
 */
async function saveMySign(formData) {
  const respone = await apiClient.post('/v1/users/me/signature', formData, {
    withAuth: true,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return respone.data;
}

/**
 * 사원번호로 개별 사원 정보 조회 API
 * GET /api/v1/users/employees/{employeeNumber}
 * (PcController에서 UserController로 마이그레이션)
 * @param {number} employeeNumber - 조회할 사원번호
 * @returns {Promise<Object>} 서버 응답 데이터
 */
async function getEmployeeInfo(employeeNumber) {
  const response = await apiClient.get(`/v1/users/employees/${employeeNumber}`, {
    withAuth: true,
  });
  return response.data;
}

/**
 * 관리자 직원 리스트 조회 API
 * POST /api/v1/organizations/employees/admin
 * @param {Object} payload - RequestEmpDataDTO 형식
 * @returns {Promise<Object>} 서버 응답 데이터
 */
async function getAdminEmployeeList(payload) {
  const response = await apiClient.post('/v1/organizations/employees/admin', payload, {
    withAuth: true,
  });
  return response.data;
}

/**
 * 관리자 직원 추가 API (admin 사용)
 * POST /api/v1/organizations/employees/add
 * @param {Object} payload - RequestEmpDataDTO 형식
 * @returns {Promise<Object>} 서버 응답 데이터
 */
async function createAdminEmployee(payload) {
  const response = await apiClient.post('/v1/organizations/employees/add', payload, {
    withAuth: true,
  });
  return response.data;
}

/**
 * 관리자 직원 수정 API (admin 사용)
 * PUT /api/v1/organizations/employees/modify
 * @param {Object} payload - RequestEmpDataDTO 형식
 * @returns {Promise<Object>} 서버 응답 데이터
 */
async function updateAdminEmployee(payload) {
  const response = await apiClient.put('/v1/organizations/employees/modify', payload, {
    withAuth: true,
  });
  return response.data;
}

export {
  deleteEmployeeDelegate,
  getEmployeeByName,
  getEmployeeByTeam,
  getEmployeesByCompany,
  getEmployeeDelegate,
  putEmployeeDelegate,
  getMySign,
  saveMySign,
  getEmployeeInfo,
  getAdminEmployeeList,
  createAdminEmployee,
  updateAdminEmployee,
};
